import { UploadDocumentType } from "../../../types";

import { DocumentUpload } from "./document-upload";

export const ProfitAndLossDocumentUploadPanel = ({
  error,
  onUploadSuccess,
}: {
  error?: string;
  onUploadSuccess?: () => void;
}) => {
  return (
    <DocumentUpload
      documentType={UploadDocumentType.PROFIT_AND_LOSS}
      supportedFileExtensions={[".xlsx", ".pdf"]}
      fileSizeLimitMB={10}
      showHelpText={false}
      error={error}
      onUploadSuccess={onUploadSuccess}
      fullScreenDropzone={false}
    />
  );
};
